import { ReactElement, ReactNode, useState } from "react"
import { v4 as uuid4 } from "uuid"

import CreateEVDCDeviceProvider from "./baseProviders/createEVDCDeviceProvider"
import { useGetUserData } from "../../../../../hooks/useGetUserData"
import { getEmptyEVDCDeviceFormData } from "../../formSpecs/evdcSpec"
import { EVDCDeviceFormData } from "../../types/providerTypes"

interface IPublishEVDCDeviceProviderProps {
    children: ReactNode
}

/** Provide for the publish EVDC provider form */
const PublishEVDCDeviceProvider = ({
    children,
}: IPublishEVDCDeviceProviderProps): ReactElement => {
    const [formData, setFormData] = useState<EVDCDeviceFormData>(
        getEmptyEVDCDeviceFormData()
    )

    const { isEnaSysAdmin } = useGetUserData()

    const [attachmentUUID] = useState<string>(uuid4())

    return (
        <CreateEVDCDeviceProvider
            formData={formData}
            setFormData={setFormData}
            formDataIsLoading={false}
            canEditManufacturer={isEnaSysAdmin}
            attachmentUUID={attachmentUUID}
        >
            {children}
        </CreateEVDCDeviceProvider>
    )
}

export default PublishEVDCDeviceProvider
